export default __webpack_public_path__ + "static/media/delete-icon.70a8e256.svg";